import { Tabs } from '@heroui/react';
import type { LeaderboardPeriod } from '../../../api/dashboard';
import { secondaryPageTabClassName } from '../../../components/ui/page-tab-classes';

const PERIOD_OPTIONS: { id: LeaderboardPeriod; label: string; ariaLabel: string }[] = [
  { id: 'all', label: 'Geral', ariaLabel: 'Todo o período' },
  { id: 'month', label: 'Mês', ariaLabel: 'Mês' },
  { id: 'week', label: 'Semana', ariaLabel: 'Semana' },
];

interface PeriodToggleProps {
  period: LeaderboardPeriod;
  onPeriodChange: (period: LeaderboardPeriod) => void;
}

export function PeriodToggle({ period, onPeriodChange }: PeriodToggleProps) {
  return (
    <Tabs
      variant="secondary"
      selectedKey={period}
      onSelectionChange={(key) => {
        const selected = String(key);
        if (selected === 'week' || selected === 'month' || selected === 'all') {
          onPeriodChange(selected);
        }
      }}
    >
      <Tabs.ListContainer>
        <Tabs.List aria-label="Período" className="w-full">
          {PERIOD_OPTIONS.map((option) => (
            <Tabs.Tab
              key={option.id}
              id={option.id}
              aria-label={option.ariaLabel}
              className={secondaryPageTabClassName}
            >
              {option.label}
              <Tabs.Indicator />
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs.ListContainer>
    </Tabs>
  );
}
